export default __webpack_public_path__ + "static/img-ml-vs-programming--mobile-9d2a5e5c2737b6dbb32818d7f3ca9899.png";